(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Quick view -> Quick add (text only) */
  (() => {
    const relabel = () => {
      document
        .querySelectorAll('.quick-add__button, quick-add-component button, .quick-add button')
        .forEach((btn) => {
          const walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (/quick\s*view/i.test(node.nodeValue)) {
              node.nodeValue = node.nodeValue.replace(/quick\s*view/i, 'Quick add');
            }
          }
          const label = btn.getAttribute('aria-label');
          if (label && /quick\s*view/i.test(label)) {
            btn.setAttribute('aria-label', label.replace(/quick\s*view/i, 'Quick add'));
          }
        });
    };
    document.addEventListener('DOMContentLoaded', () => {
      relabel();
      new MutationObserver(relabel).observe(document.body, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
